import { memo } from 'react';
import { BarChart3, Zap, Eye } from 'lucide-react';

const ACTIONS = [
  { id: 'market', label: 'Market', icon: BarChart3 },
  { id: 'boosters', label: 'Boosters', icon: Zap },
  { id: 'watchlist', label: 'Watchlist', icon: Eye },
];

export default memo(function QuickActionBar({ onAction }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid="quick-action-bar">
      {ACTIONS.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onAction?.(id)}
          className="shrink-0 flex flex-col items-center gap-1 px-3 py-2 rounded-xl bg-card border border-border/60 hover:border-border/80 hover:shadow-sm active:scale-[0.98] transition-all min-w-[60px]"
          data-testid={`quick-action-${id}`}
        >
          <Icon className="h-4 w-4 text-muted-foreground" />
          <span className="text-[9px] text-muted-foreground font-medium">{label}</span>
        </button>
      ))}
    </div>
  );
});
